import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP = `${TASK_SERVICE}/work-order-template-assignment-template-maps`;

export const workOrderTemplateAssignmentTemplateMaps = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },

  getByOrderAssignmentTemplateId: async ({
    workOrderTemplateId,
    assignmentTemplateId,
    signal,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/work-order-template/${workOrderTemplateId}/assignment-template/${assignmentTemplateId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },

  getByAssignmentOrderTemplateId: async ({
    workOrderTemplateId,
    assignmentTemplateId,
    signal,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/assignment-template/${assignmentTemplateId}/work-order-template/${workOrderTemplateId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },

  create: async ({ data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  updateByOrderAssignmentTemplateId: async ({
    workOrderTemplateId,
    assignmentTemplateId,
    data,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/work-order-template/${workOrderTemplateId}/assignment-template/${assignmentTemplateId}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  updateByAssignmentOrderTemplateId: async ({
    workOrderTemplateId,
    assignmentTemplateId,
    data,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/assignment-template/${assignmentTemplateId}/order-template/${workOrderTemplateId}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  deleteByOrderAssignmentTemplateId: async ({
    workOrderTemplateId,
    assignmentTemplateId,
    toastMessageConfig = {},
    data,
  }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/work-order-template/${workOrderTemplateId}/assignment-template/${assignmentTemplateId}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  deleteByAssignmentOrderTemplateId: async ({
    workOrderTemplateId,
    assignmentTemplateId,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/assignment-template/${assignmentTemplateId}/order-template/${workOrderTemplateId}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
